import React from "react";

// import { emergency_contact_type } from "./interfaces";
import Address from "./Address";
const EmergencyContact = ({ emergency }) => {
  if (emergency && emergency.length > 0) {
    const primary_address = emergency[0];
    const adds =
      primary_address.address === null ? [] : [primary_address.address];
    return (
      <div>
        {primary_address.ep_name} - {primary_address.relation} <br />
        <Address addresses={adds} />
      </div>
    );
  } else return <></>;
};

export default EmergencyContact;
